module.exports = __webpack_public_path__ + "media/levelup.83a1d48b.mp3";